import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { createStyles } from '@mantine/styles';
import { THUMB_SIZES } from '../Thumb/Thumb.styles.js';
var SATURATION_HEIGHTS = {
  xs: 100,
  sm: 110,
  md: 120,
  lg: 140,
  xl: 160
};
var useStyles = createStyles(function (theme, _ref, getRef) {
  var _saturation;

  var size = _ref.size;
  var position = -theme.fn.size({
    size: size,
    sizes: THUMB_SIZES
  }) / 2 - 1;
  var saturationThumb = {
    ref: getRef("saturationThumb")
  };
  return {
    saturationThumb: saturationThumb,
    saturation: (_saturation = {
      boxSizing: "border-box",
      position: "relative",
      height: theme.fn.size({
        size: size,
        sizes: SATURATION_HEIGHTS
      }),
      borderRadius: theme.radius.sm,
      margin: theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) / 2,
      WebkitTapHighlightColor: "transparent"
    }, _defineProperty(_saturation, "&:focus .".concat(saturationThumb.ref), {
      outline: "none",
      boxShadow: "0 0 0 1px ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white, ", 0 0 0 3px ").concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5])
    }), _defineProperty(_saturation, "&:focus:not(:focus-visible) .".concat(saturationThumb.ref), {
      boxShadow: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
    }), _saturation),
    saturationOverlay: {
      position: "absolute",
      boxSizing: "border-box",
      borderRadius: theme.radius.sm,
      top: position,
      left: position,
      right: position,
      bottom: position
    }
  };
});
export default useStyles;